export default class ListingEmailRequest {
    /**
     * @param {Object} data
     * @param {string|number|null} data.relatedId
     * @param {string|null} data.relatedType
     * @param {Object} [data.docFile={}]
     * @param {string|null} data.docLabel
     */
    constructor({ relatedId = null, relatedType = null, docFile = {}, docLabel = null } = {}) {
        this.relatedId = relatedId;
        this.relatedType = relatedType;
        this.docFile = docFile;
        this.docLabel = docLabel;
    }

    getRelatedId() {
        return this.relatedId;
    }

    getRelatedType() {
        return this.relatedType;
    }

    getDocFile() {
        return this.docFile;
    }

    getDocLabel() {
        return this.docLabel;
    }
}
